import { render, staticRenderFns } from "./Unauthorize.vue?vue&type=template&id=38c0a9ca"
import script from "./Unauthorize.vue?vue&type=script&lang=js"
export * from "./Unauthorize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports